import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { EntityCollectionService, EntityServices } from '@ngrx/data';
import { select, Store } from '@ngrx/store';
import clone from 'just-clone';
import moment from 'moment';
import { combineLatest, Observable, of, ReplaySubject } from 'rxjs';
import {
    filter,
    map,
    skip,
    take,
    takeWhile,
    tap,
    withLatestFrom
} from 'rxjs/operators';
import * as fromSettings from '../../company-setting';
import * as fromLookups from '../../lookups';
import {
    IAuthorizationType,
    IServiceItem,
    ITask,
    LoadPayrollItems
} from '../../lookups';
import { PayrollItem } from '../../payroll/item/store';
import * as fromShared from '../../shared';
import { Process, uniqBy } from '../../shared';
import { SelectItem } from '../../shared/efaact-primeng.module';
import { IShowErrors } from '../../shared/errors-sidenav';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromUser from '../../user-info';
import { IUserInfo } from '../../user-info';
import * as fromStore from '../store';
import * as fromUa from '../store';
import { UserAuthorization } from '../store';
import * as fromDataServices from '../../data-services';
@Component({
    selector: 'ef-user-authorization-container',
    templateUrl: './user-authorization-container.component.html',
    styleUrls: ['./user-authorization-container.component.scss'],
    standalone: false
})
export class UserAuthorizationContainerComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    authorizations$: Observable<Array<fromStore.UserAuthorization>>;
    useClass$: Observable<boolean>;
    AuthAutomatedPI$: Observable<boolean>;
    process$: Observable<Process>;
    directReports$: Observable<fromLookups.IDirectReport[]>;
    directReportsFilterSelectItems$: Observable<SelectItem[]>;
    employeeswithoutauths$: Observable<boolean>;
    activeReports$: Observable<fromLookups.IDirectReport[]>;
    tasksFilterSelectItems$: Observable<SelectItem[]>;
    payrollItemsFilterSelectItems$: Observable<SelectItem[]>;
    serviceItemsFilterSelectItems$: Observable<SelectItem[]>;
    classItemsFilterSelectItems$: Observable<SelectItem[]>;
    userAuthTypes$: Observable<IAuthorizationType[]>;
    userAuthTypesSelectItems$: Observable<SelectItem[]>;
    tasks$: Observable<ITask[]>;
    tasksSelectItems$: Observable<SelectItem[]>;
    activeTasks$: Observable<SelectItem[]>;
    serviceItems$: Observable<IServiceItem[]>;
    serviceItemsSelectItems$: Observable<SelectItem[]>;
    activeServiceItems$: Observable<SelectItem[]>;
    userGroups$: Observable<fromLookups.IUserGroup[]>;
    authClasses$: Observable<fromLookups.IAuthorizationClass[]>;
    authClassesSelectItems$: Observable<SelectItem[]>;
    payrollItems$: Observable<PayrollItem[]>;
    errors$: Observable<string[]>;
    selectedError$: Observable<IShowErrors>;
    pendingAuthsCount$: Observable<number>;
    pendingAuthorizations$: Observable<fromStore.PendingAuthorization[]>;
    userInfo$: Observable<IUserInfo>;
    yearOptions$: Observable<SelectItem[]>;
    //ManageUsersModelDS: EntityCollectionService<fromDataServices.ManageUsers.LoginModel>;
    modifiedDatesSelectItems$: Observable<SelectItem[]>;
    active = true;
    isLoading = true;
    ShowErrorSubject = new ReplaySubject<fromShared.Errors.IShowErrors>(1);
    OnSaveErrorSubject = new ReplaySubject<UserAuthorization>(1);
    OnAddPendingSubject = new ReplaySubject<{
        directReports: Array<fromLookups.IDirectReport>;
        tasks: Array<Partial<fromLookups.ITask>>;
        serviceItems: Array<Partial<fromLookups.IServiceItem>>;
        classes: Array<Partial<fromLookups.IAuthorizationClass>>;
        authTypes: Array<Partial<fromLookups.IAuthorizationType>>;
        endDate: Date;
        modifiedDate: Date;
        endDateOperator: string;
        AddAuthMode: boolean;
        AddAuthValue: boolean;
        showSI: boolean;
        EmployeeAuthStartDate: Date;
        EmployeeAuthEndDate: Date;
    }>();
    constructor(
        private store: Store,
        private log: LoggingService,
        public entityServices: EntityServices
    ) {
        // this.ManageUsersModelDS =
        //     entityServices.getEntityCollectionService<fromDataServices.ManageUsers.LoginModel>(
        //         fromDataServices.ManageUsers.entityName
        //     );
        this.store.dispatch(new fromLookups.GetCreditCards('CreditCard'));
    }

    ngOnInit(): void {
        this.store.dispatch(new fromLookups.LoadPayrollItems());
        this.store.dispatch(new fromLookups.LoadServiceItems());
        this.store.dispatch(new fromLookups.LoadTasks());

        this.store.dispatch(
            fromSettings.getCompanySetting({ SettingType: 'UseClass' })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'AuthAutomatedPI'
            })
        );
        this.store.dispatch(
            fromSettings.getCompanySetting({
                SettingType: 'employeeswithoutauths'
            })
        );
        //this.ManageUsersModelDS.clearCache();
        // this.ManageUsersModelDS.getWithQuery({
        //     ShowInactive: 'false',
        //     UserFilterID: '7'
        // });
        this.store.dispatch(fromUa.clearUserAuthorizations());
        this.setupObservables();
        this.setupSubscriptions();
    }
    ngAfterViewInit(): void {}
    ngOnDestroy(): void {
        this.active = false;
    }
    setupObservables() {
        this.process$ = this.store.pipe(select(fromShared.selectCurrent));
        this.userInfo$ = this.store.pipe(select(fromUser.getUserInfo));
        this.AuthAutomatedPI$ = this.store.pipe(
            select(fromSettings.getSettingBooleanValue('AuthAutomatedPI'))
        );
        this.useClass$ = this.store.pipe(
            select(fromSettings.getSettingBooleanValue('UseClass'))
        );

        this.payrollItems$ = this.store.pipe(
            select(fromLookups.getPayrollItemsLookup),
            map(x => clone(x) as PayrollItem[]),
            map(payrollItems =>
                payrollItems
                    .filter(x => x.IsActive === true)
                    .sort((a, b) => a.PayrollItem.localeCompare(b.PayrollItem))
            )
        );

        this.serviceItems$ = this.store.pipe(
            select(fromLookups.getServiceItemsLookup)
        );
        this.serviceItemsSelectItems$ = this.serviceItems$.pipe(
            map(x => clone(x) as fromLookups.IServiceItem[]),
            map(x =>
                x
                    .map(y => ({ label: y.ServiceItem, value: y.SIListID }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );
        this.activeServiceItems$ = this.serviceItems$.pipe(
            map(a => a.filter(x => x.IsActive)),
            map(x => clone(x) as fromLookups.IServiceItem[]),
            map(x =>
                x
                    .map(y => ({ label: y.ServiceItem, value: y.SIListID }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );

        this.authorizations$ = this.store.pipe(
            select(fromUa.selectAll),
            skip(1),
            map(x => clone(x) as fromStore.UserAuthorization[]),
            withLatestFrom(this.payrollItems$, this.serviceItems$),
            tap(([auths, pi, si]) =>
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:setupObservables:authorizations$',
                    auths,
                    pi,
                    si
                })
            ),
            map(([auths, pi, si]) =>
                auths.map(auth => {
                    const p = pi.find(x => x.PIListID === auth.PIListID);
                    const s = si.find(x => x.SIListID == auth.SIListID);
                    if (!p) {
                        this.log.verbose({
                            type: 'UserAuthorizationContainerComponent:setupObservables:authorizations$',
                            message: `Payroll Item not found for PIListID: ${auth.PIListID}`
                        });
                    }
                    if (!s) {
                        this.log.verbose({
                            type: 'UserAuthorizationContainerComponent:setupObservables:authorizations$',
                            message: `Service Item not found for SIListID: ${auth.SIListID}`
                        });
                    }
                    return {
                        ...auth,
                        ServiceItem: s?.ServiceItem ?? auth.SIListID,
                        PayrollItem: p?.PayrollItem ?? auth.PIListID,
                        ModifiedDateOnly: moment(auth.ModifiedDateTime).format(
                            'MM/DD/YYYY'
                        ),
                        IsHolidayAuth: p ? p.IsHolidayPI || false : false
                    };
                })
            ),
            tap(auths => {
                this.isLoading = false;
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:setupObservables:authorizations$:mapped',
                    auths
                });
            })
        );

        this.serviceItemsFilterSelectItems$ = combineLatest([
            this.authorizations$,
            this.serviceItems$
        ]).pipe(
            map(([auths, items]) =>
                auths.map(a =>
                    items.find(i => i.SIListID === a.SIListID)
                        ? items.find(i => i.SIListID === a.SIListID)
                        : {
                              SIListID: a.SIListID,
                              ServiceItem: 'Unknown Service Item'
                          }
                )
            ),
            map(
                items =>
                    uniqBy(items, x => x.SIListID) as fromLookups.IServiceItem[]
            ),
            map(items =>
                items
                    .map(i => ({
                        label: i.ServiceItem,
                        value: i.SIListID
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );

        this.directReports$ = this.store.pipe(
            select(fromLookups.getDirectReportsLookup),
            tap(directReports =>
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:diretReports$',
                    directReports
                })
            ),
            map(x => clone(x)),
            map(reports =>
                reports.sort((a, b) =>
                    a.EmployeeName.localeCompare(b.EmployeeName)
                )
            )
        );
        this.activeReports$ = combineLatest([
            this.directReports$.pipe(
                map(x => clone(x)),
                map(reports =>
                    reports
                        .filter(report => report.IsActive && report.eUserID != null)
                        .sort((a, b) =>
                            a.EmployeeName.localeCompare(b.EmployeeName)
                        )
                )
            ),
            //this.ManageUsersModelDS.entities$
        ]).pipe(
            map(([directReports]) => {
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:activeReports$',
                    directReports
                });
                return directReports;
                // return directReports.filter(x =>
                //     users
                //         .filter(y => !!y.EUserID)
                //         .find(y => y.EmployeeListID === x.EmployeeListID)
                // );
            })
        );

        this.directReportsFilterSelectItems$ = combineLatest([
            this.authorizations$,
            this.directReports$
        ]).pipe(
            map(([auths, items]) =>
                auths.map(a => {
                    const report = items.find(
                        i => i.EmployeeListID === a.EmployeeListID
                    );
                    return {
                        label:
                            report?.EmployeeName ||
                            a.EmployeeName ||
                            'Unknown User',
                        value: a.EmployeeListID
                    };
                })
            ),
            map(items => uniqBy(items, x => x.value) as SelectItem[]),
            map(items =>
                items.sort((a, b) => a.label.localeCompare(b.label))
            )
        );
        this.employeeswithoutauths$ = this.store.pipe(
            select(fromSettings.getSettingBooleanValue('employeeswithoutauths'))
        );

        this.userAuthTypes$ = this.store.pipe(
            select(fromLookups.getAuthorizationTypesLookup)
        );
        this.userAuthTypesSelectItems$ = this.userAuthTypes$.pipe(
            map(types =>
                types
                    .map(y => ({
                        label: y.AuthType,
                        value: y.AuthTypeId,
                        title: y.AuthTypeDesc
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );

        this.tasks$ = this.store.pipe(select(fromLookups.getTasksLookup));
        this.tasksSelectItems$ = this.tasks$.pipe(
            map(tasks =>
                tasks
                    .map(task => ({
                        label: task.TaskLongName,
                        value: task.TaskListID
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );
        this.activeTasks$ = this.tasks$.pipe(
            map(tasks =>
                tasks
                    .filter(y => y.IsActive)
                    .map(task => ({
                        label: task.TaskLongName,
                        value: task.TaskListID
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );
        this.tasksFilterSelectItems$ = combineLatest([
            this.authorizations$,
            this.tasks$
        ]).pipe(
            map(([auths, items]) =>
                auths.map(a => items.find(i => i.TaskListID === a.TaskListID))
            ),
            map(
                items => uniqBy(items, x => x.TaskListID) as fromLookups.ITask[]
            ),
            map(items =>
                items
                    .map(i => ({
                        label: i.TaskLongName,
                        value: i.TaskListID
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );

        this.userGroups$ = this.store.pipe(
            select(fromLookups.getUserGroupsLookup),
            map(x => clone(x)),
            map(groups =>
                groups.sort((a, b) => a.GroupName.localeCompare(b.GroupName))
            )
        );
        this.authClasses$ = this.store.pipe(
            select(fromLookups.getAuthClassesLookup),
            tap(classes =>
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:authClasses$',
                    classes
                })
            )
        );
        this.authClassesSelectItems$ = this.authClasses$.pipe(
            tap(classes =>
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:authClassesSelectItems$',
                    classes
                })
            ),
            map(x => clone(x) as fromLookups.IAuthorizationClass[]),
            map(classes => [
                {
                    ClassListID: 'na',
                    ClassName: 'Not Assigned',
                    IsActive: true
                },
                ...classes.sort((a, b) =>
                    a.ClassName.localeCompare(b.ClassName)
                )
            ]),
            map(classes =>
                classes
                    .filter(x => x.IsActive === true)
                    .map(x => ({ label: x.ClassName, value: x.ClassListID }))
            )
        );
        this.classItemsFilterSelectItems$ = combineLatest([
            this.authorizations$,
            this.authClassesSelectItems$
        ]).pipe(
            tap(([auths, items]) =>
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:classItemsFilterSelectItems$',
                    auths,
                    items
                })
            ),
            map(([auths, items]) =>
                auths.map(a => items.find(p => p.value === a.ClassListID))
            ),
            tap(items =>
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:classItemsFilterSelectItems$:filtered',
                    items
                })
            ),
            filter(items => !!items && items.length > 0),
            map(items => uniqBy(items, x => x.value) as SelectItem[])
        );

        this.payrollItemsFilterSelectItems$ = combineLatest([
            this.authorizations$,
            this.payrollItems$
        ]).pipe(
            map(([auths, items]) =>
                auths.map(a => items.find(i => i.PIListID === a.PIListID))
            ),
            map(items => uniqBy(items, x => x.PIListID) as PayrollItem[]),
            map(items =>
                items
                    .map(i => ({
                        label: i.PayrollItem,
                        value: i.PIListID
                    }))
                    .sort((a, b) => a.label.localeCompare(b.label))
            )
        );

        this.errors$ = this.store.pipe(
            select(fromUa.getUserAuthorizationErrors)
        );

        this.selectedError$ = this.store.pipe(
            select(fromShared.Errors.getShowErrors)
        );

        this.pendingAuthsCount$ = this.store.pipe(
            select(fromUa.getPendingAuthorizationCount),
            tap(x =>
                this.log.debug({
                    type: 'UserAuthorizationContainerComponent:pendingAuthsCount$',
                    x
                })
            )
        );

        this.pendingAuthorizations$ = this.store.pipe(
            select(fromUa.getPendingAuthorizations),
            map(items => clone(items) as fromStore.PendingAuthorization[])
        );
        this.yearOptions$ = of(
            Array.from(Array(11).keys())
                .map(x => ({
                    label: moment()
                        .add(x - 10, 'years')
                        .year()
                        .toString(),
                    value: moment()
                        .add(x - 10, 'years')
                        .year()
                }))
                .reverse()
        );
        this.modifiedDatesSelectItems$ = this.authorizations$.pipe(
            map(auths =>
                auths.filter(
                    auth =>
                        !!auth.ModifiedDateTime &&
                        moment(auth.ModifiedDateTime).isValid()
                )
            ),
            map(auths =>
                auths.sort(
                    (a, b) =>
                        (a.ModifiedDateTime
                            ? a.ModifiedDateTime.valueOf()
                            : 0) -
                        (b.ModifiedDateTime ? b.ModifiedDateTime.valueOf() : 0)
                )
            ),
            map(auths =>
                auths.map(a => ({
                    label: moment(a.ModifiedDateTime).format('MM/DD/YYYY'),
                    value: moment(a.ModifiedDateTime).format('MM/DD/YYYY')
                }))
            ),
            map(auths => uniqBy(auths, x => x.value))
        );
    }
    setupSubscriptions() {
        combineLatest([this.userInfo$, this.process$])
            .pipe(take(1))
            .subscribe(([userInfo, process]) => {
                this.store.dispatch(
                    new fromLookups.LoadDirectReports({
                        user: userInfo,
                        activeOnly: true,
                        processId: process.ProcessID
                    })
                );
            });
        this.directReports$
            .pipe(withLatestFrom(this.userInfo$, this.tasks$))
            // combineLatest([this.userInfo$, this.directReports$, this.tasks$])
            .pipe(
                tap(x => x),
                takeWhile(() => this.active),
                skip(1),
                tap(([directReports, userInfo, tasks]) =>
                    this.log.verbose({
                        type: 'UserAuthorizationContainerComponent:setupSubscriptions:combineLatest(this.userInfo$, this.directReports$, this.tasks$)',
                        userInfo,
                        directReports,
                        tasks
                    })
                )
            )

            .subscribe(([r, u, t]) => {
                let dr;
                let tasks;
                switch (u.DefaultRoleGroupID) {
                    case fromUser.UserRoleEnum.Supervisor:
                        dr = r;
                        tasks = undefined;
                        break;
                    case fromUser.UserRoleEnum.TaskManager:
                        dr = undefined;
                        tasks = t;
                        break;
                    default:
                        dr = undefined;
                        tasks = undefined;
                        break;
                }
                this.store.dispatch(new fromLookups.LoadServiceItems());

                // this.store.dispatch(
                //     new LoadPayrollItems([
                //         ...(r.map(z => z.EmployeeListID) || [])
                //     ])
                // ); //commented out 04/09/24 -- this will use the payroll items from the load on login
                this.store.dispatch(
                    fromUa.getUserAuthorizations({
                        endDate: new Date(
                            Date.UTC(
                                new Date().getUTCFullYear(),
                                new Date().getUTCMonth(),
                                new Date().getUTCDate()
                            )
                        ),
                        endDateOperator: undefined,
                        modifiedDate: undefined,
                        directReports: dr,
                        tasks: tasks
                    })
                );
            });
        combineLatest([this.process$, this.ShowErrorSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([process, event]) => {
                this.store.dispatch(
                    new fromShared.Errors.SetShowErrors({
                        open: event.open,
                        MsgEntityID: event.MsgEntityID,
                        MsgProcessID: process.ProcessID
                    })
                );
            });

        combineLatest([
            this.OnAddPendingSubject,
            this.tasks$,
            this.serviceItems$,
            this.userAuthTypes$,
            this.directReports$,
            this.authClasses$
        ])
            .pipe(takeWhile(() => this.active))
            .subscribe(
                ([
                    pendingAdd,
                    tasks,
                    serviceItems,
                    authTypes,
                    directReports,
                    authClasses
                ]) => {
                    this.log.verbose({
                        type: 'UserAuthorizationContainerComponent:OnAddPendingSubject',
                        pendingAdd,
                        tasks,
                        serviceItems,
                        authTypes,
                        directReports,
                        authClasses
                    });

                    const action = {
                        ...pendingAdd,
                        directReports:
                            pendingAdd.directReports &&
                            pendingAdd.directReports.map(x =>
                                directReports.find(
                                    d => d.EmployeeListID === x.EmployeeListID
                                )
                            ),
                        tasks:
                            pendingAdd.tasks &&
                            pendingAdd.tasks.map(x =>
                                tasks.find(t => t.TaskListID === x.TaskListID)
                            ),
                        serviceItems:
                            pendingAdd.serviceItems &&
                            pendingAdd.serviceItems.map(x =>
                                serviceItems.find(
                                    s => s.SIListID === x.SIListID
                                )
                            ),
                        authTypes:
                            pendingAdd.authTypes &&
                            pendingAdd.authTypes.map(x =>
                                authTypes.find(
                                    a => a.AuthTypeId === x.AuthTypeId
                                )
                            ),
                        classes:
                            pendingAdd.classes &&
                            pendingAdd.classes.map(x =>
                                authClasses.find(
                                    c => c.ClassListID === x.ClassListID
                                )
                            )
                    };
                    this.log.verbose({
                        type: 'UserAuthorizationContainerComponent:OnAddPendingSubject',
                        action
                    });

                    this.store.dispatch(
                        fromUa.addPendingUserAuthorizations(action)
                    );
                }
            );
        combineLatest([this.OnSaveErrorSubject, this.process$])
            .pipe(takeWhile(() => this.active))
            .subscribe(([auth, process]) => {
                this.log.verbose({
                    type: 'UserAuthorizationContainerComponent:OnSaveErrorSubject',
                    auth,
                    process
                });
                this.store.dispatch(
                    new fromShared.Errors.SetErrors([
                        {
                            StatusCode: auth.Status.StatusCode,
                            Message: auth.Status.Message,
                            MsgProcessID: process.ProcessID,
                            MsgEntityID: auth.id
                        }
                    ])
                );
            });
    }
    OnAuthorizationChanged($event) {}
    OnAddModeChanged(value) {
        this.log.debug({
            type: 'UserAuthorizationContainerComponent:OnAddModeChanged',
            value
        });
        if (
            (value.AddAuthMode && (value.directReports || value.tasks)) ||
            !value.AddAuthMode
        ) {
            this.store.dispatch(
                fromUa.getUserAuthorizations({
                    ...value,
                    AddAuthAction: false
                })
            );
        }
    }
    OnDateFilterChanged(value: {
        EmployeeAuthEndDate: Date;
        modifiedDate: Date;
        endDateOperator: string;
        AddAuthMode: boolean;
    }) {
        this.isLoading = true;
        this.log.debug({
            type: 'UserAuthorizationContainerComponent:OnDateFilterChanged',
            value
        });
        this.store.dispatch(
            fromUa.getUserAuthorizations({
                ...value,
                AddAuthAction: false
            })
        );
    }
    OnAddPending(value: {
        directReports: Array<fromLookups.IDirectReport>;
        tasks: Array<fromLookups.ITask>;
        serviceItems: Array<fromLookups.IServiceItem>;
        classes: Array<fromLookups.IAuthorizationClass>;
        authTypes: Array<fromLookups.IAuthorizationType>;
        endDate: Date;
        modifiedDate: Date;
        endDateOperator: string;
        AddAuthMode: boolean;
        AddAuthValue: boolean;
        showSI: boolean;
        EmployeeAuthStartDate: Date;
        EmployeeAuthEndDate: Date;
    }) {
        this.log.debug({
            type: 'UserAuthorizationContainerComponent:OnAddPending',
            value
        });
        this.OnAddPendingSubject.next(value);
    }
    OnCopy(authorizations: UserAuthorization[]) {
        this.log.debug({
            type: 'UserAuthorizationContainerComponent:OnCopyAuthorization',
            authorizations
        });
        this.store.dispatch(
            fromUa.putUserAuthorzations({
                authorizations: authorizations.map(a => ({
                    ...a,
                    CopyAuth: true
                }))
            })
        );
    }
    OnShowHoliday($event: boolean) {
        this.log.debug({
            type: 'UserAuthorizationContainerComponent:OnShowHoliday',
            value: $event
        });
    }
    OnSaveError($event: UserAuthorization) {
        this.OnSaveErrorSubject.next($event);
    }
    OnShowError($event) {
        this.ShowErrorSubject.next($event);
    }
    OnSave(items: UserAuthorization[]) {
        this.store.dispatch(
            fromUa.putUserAuthorzations({ authorizations: items })
        );
    }
    OnDelete(items: number[]) {
        this.log.debug({
            type: 'UserAuthorizationContainerComponent:OnDeleteAuthorizations',
            items
        });
        this.store.dispatch(fromUa.removeUserAuthorizations({ ids: items }));
    }
}
